/* CHARITY_SHOPS */
export const GET_CHARITY_SHOPS = "GET_CHARITY_SHOPS"
export const GET_CHARITY_SHOPS_SUCCESS = "GET_CHARITY_SHOPS_SUCCESS"
export const GET_CHARITY_SHOPS_FAIL = "GET_CHARITY_SHOPS_FAIL"